/**
 * Layout utility styles for flexbox, grid, and positioning patterns.
 */
import * as stylex from "@stylexjs/stylex";

import { space } from "../tokens.stylex";

export const layout = stylex.create({
  centered: {
    display: "flex",
    minHeight: "100vh",
    alignItems: "center",
    justifyContent: "center",
  },
  centeredColumn: {
    display: "flex",
    minHeight: "100vh",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  flexRow: {
    display: "flex",
    alignItems: "center",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  flexBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  gap2: { gap: space.sm },
  gap4: { gap: space.md },
  gap6: { gap: space.lg },
});

export const grid = stylex.create({
  cols1: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
  },
  cols2: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  cols3: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  cols4: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
  },
  gap4: { gap: space.md },
  gap6: { gap: space.lg },
});
